const styles = (theme) => ({
  root: {
    display: 'flex',
    wordBreak: 'normal',
    overflowWrap: 'anywhere',
  },
});

export default styles;
